import React from 'react';
import { Loader } from 'shared/components';
import theme from './TabContentPending.scss';

export default () => (
  <div className={ theme.root }>
    <Loader />
  </div>
);
